<template>
  <div :class="[$b(), 'global-wrapper-large']">
    <!-- Title -->
    <BaseHeading
      v-if="title"
      size="h2"
      tag="h3"
      :class="$b('title')"
    >
      {{ title }}
    </BaseHeading>

    <!-- Articles -->
    <div :class="$b('articles')">
      <div
        v-for="article in articles"
        :key="article.id"
        :class="$b('article')"
      >
        <BodyCopy
          tag="div"
          :class="$b('article-title')"
          @click="toggle(article)"
        >
          {{ article.title }}
          <ExpandButton
            size="small"
            :expanded="!!expanded[article.id]"
          />
        </BodyCopy>

        <SlideDownTransition>
          <div
            v-show="expanded[article.id]"
            :class="$b('article-content-wrapper')"
          >
            <RichText
              :class="$b('article-content')"
              :content="article.bodyCopy"
            />
          </div>
        </SlideDownTransition>
      </div>
    </div>

    <!-- Footer Copy -->
    <div
      v-if="footerCopy"
      :class="$b('footer-copy')"
    >
      <RichText
        :class="$b('footer-copy-content')"
        size="body-xs"
        :content="footerCopy"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FAQBlock',
  props: {
    title: {
      type: String,
      default: null,
    },
    articles: {
      type: Array,
      default: () => [],
    },
    footerCopy: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    expanded: {},
  }),
  jsonld() {
    return {
      '@context': 'https://schema.org/',
      '@type': 'FAQPage',
      mainEntity: this.articles.map((article) => ({
        '@type': 'Question',
        name: article.title,
        acceptedAnswer: {
          '@type': 'Answer',
          text: article.bodyCopy,
        },
      })),
    }
  },
  methods: {
    toggle(article) {
      this.expanded[article.id] = !this.expanded[article.id];
    },
  },
}
</script>

<style lang="postcss">
.FAQBlock {
  @apply w-full;

  --one-column: calc(1 / 12 * (100% - (11 * 32px)) + 32px);

  @screen sm {
    padding: 0 var(--one-column);
  }
}

.FAQBlock__title {
  @apply mb-sm;
}

.FAQBlock__articles {
  @apply flex flex-col
    space-y-xxxs;
}

.FAQBlock__article {
  @apply bg-grey-100 py-xxs px-xs;
  border-radius: 4px;
}

.FAQBlock__article-title {
  @apply flex items-center justify-between
    cursor-pointer font-bold
    py-xxxs
    gap-6;

  -webkit-tap-highlight-color: transparent;
}

.FAQBlock__article-content {
  @apply my-xxs;
}

.FAQBlock__footer-copy {
  @apply mt-sm opacity-70;
}
</style>
